var _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4555_5098)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.0001 125C57.3111 124.992 45.0147 120.599 35.1941 112.564C25.3735 104.528 18.6324 93.3453 16.113 80.909C13.5935 68.4726 15.4506 55.5477 21.3695 44.3237C27.2885 33.0998 36.9054 24.267 48.5911 19.3217C62.0317 13.6439 77.1774 13.5378 90.6962 19.0269C104.215 24.516 115 35.1506 120.678 48.5912C126.355 62.0319 126.462 77.1776 120.972 90.6964C115.483 104.215 104.849 115 91.4081 120.678C84.6355 123.544 77.3542 125.014 70.0001 125ZM48.4001 42.9997C47.3324 43.0039 46.2896 43.3233 45.4028 43.9178C44.5159 44.5124 43.8244 45.3557 43.4151 46.3419C43.0057 47.328 42.8968 48.4131 43.1019 49.461C43.3071 50.5088 43.8171 51.4727 44.5681 52.2317L62.3361 69.9997L44.5691 87.7677C43.5802 88.7897 43.0326 90.1593 43.0443 91.5813C43.056 93.0033 43.6261 94.3637 44.6316 95.3692C45.6371 96.3747 46.9976 96.9448 48.4196 96.9565C49.8415 96.9682 51.2112 96.4206 52.2331 95.4317L70.0001 77.6637L87.7691 95.4317C88.7915 96.4365 90.1676 96.9995 91.6011 96.9995C93.0346 96.9995 94.4107 96.4365 95.4331 95.4317C96.4315 94.406 96.9901 93.0311 96.9901 91.5997C96.9901 90.1684 96.4315 88.7935 95.4331 87.7677L77.6651 69.9997L95.4331 52.2317C96.4219 51.2098 96.9695 49.8402 96.9578 48.4182C96.9462 46.9962 96.3761 45.6358 95.3705 44.6303C94.365 43.6248 93.0046 43.0547 91.5826 43.043C90.1606 43.0313 88.791 43.5789 87.7691 44.5677L70.0001 62.3347L52.2331 44.5677C51.7296 44.0659 51.1316 43.6689 50.4737 43.3998C49.8157 43.1306 49.1109 42.9947 48.4001 42.9997Z",
    fill: "url(#paint0_linear_4555_5098)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4555_5098)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70 132C104.242 132 132 104.242 132 70C132 35.7583 104.242 8 70 8C35.7583 8 8 35.7583 8 70C8 104.242 35.7583 132 70 132Z",
    stroke: "#FF0000",
    strokeWidth: 6
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_4555_5098)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70 139C108.108 139 139 108.108 139 70C139 31.8924 108.108 1 70 1C31.8924 1 1 31.8924 1 70C1 108.108 31.8924 139 70 139Z",
    stroke: "#FF0000",
    strokeWidth: 2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4555_5098",
    x1: 108.625,
    y1: 29.8373,
    x2: 30.0745,
    y2: 106.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F17456"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4555_5098"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 110,
    fill: "white",
    transform: "translate(15 15)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4555_5098"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 130,
    fill: "white",
    transform: "translate(5 5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_4555_5098"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 140,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.b4ed653b04e8b84b21d4036e9f6cca1d.svg";
export { ForwardRef as ReactComponent };